module.exports = __webpack_public_path__ + "media/images/Laureate-a180e558b75425639f95925b904661ad.png";